import isUndefined from 'lodash/isUndefined'
import { Defaults } from 'es-decorators'
import { FaderBaseView } from 'es6/views/fader/fader-base-view'

/**
 * Вью для затемнения экрана под попапом.
 */
@Defaults({
  el: '#js-screen-overlay',
})
export class FaderView extends FaderBaseView {
  /**
   * Переключение состояния затемнения
   * @param {boolean} state true - показан
   *                        false - скрыт
   */
  toggle (state) {
    if (!isUndefined(state)) {
      state = !state
    }
    this.$el.toggleClass('not_display', state)
  }

  /**
   * Показать попап.
   */
  show () {
    this.$el.removeClass('not_display')
  }

  /**
   * Скрыть попап.
   */
  hide () {
    this.$el.addClass('not_display')
  }
}
